import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import { DateTime } from 'luxon';

import { fillByGranularity, adjustPrecision } from './utils';

class MonthUsage extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.option = this.getOption(props)
    }

    getOption(props) {
        const { day, date } = props;

        if (!day) {
            return {}
        }

        const month_data = fillByGranularity(day, date, 'day')
            .filter(d => DateTime.fromJSDate(new Date(d.name)).hasSame(date, 'month'))
            .map(d => ({ name: d.name, value: adjustPrecision(d.value, 1, 1) }))
        if (!month_data || month_data.length === 0) {
            return {}
        }
        // console.log('month_data:', month_data);

        const month_data_usage = month_data
            .map(d => ({ name: d.name, value: d.value.Usage }))
            .map(d => DateTime.fromJSDate(new Date(d.name)).hasSame(date, 'day')
                ? Object.assign({}, d, { itemStyle: { color: '#ee6666' } })
                : d
            );
        // console.log('month_data_usage: ', month_data_usage);

        const month_data_day = month_data.map(d => DateTime.fromJSDate(new Date(d.name)).day);
        const month_data_temperature = month_data.map(d => ({ name: d.name, value: d.value.Temperature }));
        
        var option = {
            animation: false,
            tooltip: {
                position: 'top',
                formatter: (params) => (params && params.length === 2 && params[0].value)
                    ? DateTime.fromJSDate(new Date(params[0].name)).toLocaleString(DateTime.DATE_FULL)  + '<br/> <b>' + params[0].value + ' kWh / ' + params[1].value + ' °C</b>'
                    : '',
                trigger: 'axis',
                axisPointer: {
                    type: 'none',
                }
            },
            visualMap: [{
                show: false,
                type: 'continuous',
                seriesIndex: 1,
                min: 5,
                max: 35,
                inRange: { color: ['#e0e0e0', '#1976d2', '#00E676', '#FFC107', '#F44336'] },
                outOfRange: { color: ['#B71C1C'] }
            }],
            xAxis: {
                type: 'category',
                data: month_data_day,
                axisTick: { show: false },
            },
            yAxis: [{
                // show: false
                type: 'value',
                splitLine: {
                    show: false,
                },
                axisLabel: {
                    formatter: '{value} kWh',
                    fontSize: '0.6em',
                },
                min: 0,
            }, {
                type: 'value',
                splitLine: {
                    show: false,
                },
                axisLabel: {
                    formatter: '{value} °C',
                    fontSize: '0.6em',
                },
                min: value => Math.min(0, Math.floor(value.min / 10) * 10),
                max: value => Math.max(30, Math.ceil(value.max / 10) * 10),
            }],
            grid: {
                left: '50pt',
                right: '40pt',
                top: '20%',
                bottom: '20%',
            },
            series: [{
                name: 'Usage',
                type: 'bar',
                barWidth: '80%',
                barGap: '0%',
                emphasis: {
                    itemStyle: {
                        shadowBlur: 5,
                    }
                },
                markLine: {
                    silent: true,
                    symbol: 'none',
                    label: {
                        show: false,
                    },
                    lineStyle: {
                        opacity: 0.5,
                    },
                    data: [
                        { yAxis: 50 },
                        { yAxis: 100 },
                        { yAxis: 150 },
                        { yAxis: 200 },
                    ]
                },
                data: month_data_usage,
            }, {
                name: 'Temperature',
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                showSymbol: false,
                data: month_data_temperature,
            }]
        };

        return option
    }

    render() {
        const option = this.getOption(this.props);
        const { onChangeDate } = this.props;

        return (
            <ReactEcharts
                option={option}
                notMerge={false}
                lazyUpdate={false}
                style={{ height: '20vmax' }}
                onEvents={{ 'click': d => { onChangeDate(new Date(d.name)); } }}
            />
        );
    }
}

MonthUsage.propTypes = {
    day: PropTypes.array,
    date: PropTypes.instanceOf(Date),
    onChangeDate: PropTypes.func,
};

MonthUsage.defaultProps = {
    day: [],
    date: Date.now(),
    onChangeDate: () => { },
}

export default MonthUsage;
